import I18n from 'lib/i18n'
import React from 'react'
import { useActions, useValues } from 'kea'

import Checkbox from 'lib/forms/checkbox-svg'

import filtersLogic from '~/scenes/search/filters-page/logic'

export default function Level () {
  const { unsavedFilter } = useValues(filtersLogic)
  const { updateUnsavedFilter } = useActions(filtersLogic)

  function toggleLevel (level) {
    const currentValue = unsavedFilter.levels
    updateUnsavedFilter({ levels: currentValue === level ? '' : level })
  }

  return (
    <div className='filter-section'>
      <div className='filter-title'>{I18n.t('react.search.all_filters.class_level')}</div>
      <div className='checkbox-list'>
        <Checkbox checked={unsavedFilter.levels === 'beginner'} onChange={() => toggleLevel('beginner')}>
          {I18n.t('main.filter.level_2')}
        </Checkbox>
        <Checkbox checked={unsavedFilter.levels === 'intermediate'} onChange={() => toggleLevel('intermediate')}>
          {I18n.t('main.filter.level_3')}
        </Checkbox>
        <Checkbox checked={unsavedFilter.levels === 'advanced'} onChange={() => toggleLevel('advanced')}>
          {I18n.t('main.filter.level_4')}
        </Checkbox>
      </div>
    </div>
  )
}
